/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
// global variables for otp flow
const handleVerifyCustomerId = async (event, customerId) => {
    document.getElementById('send-otp-code').disabled = true;
    event.preventDefault();

    const errorElement = document.querySelector('.verify-customer-id-error-banner.hidden');
    const errorClass = '.verify-customer-id-error-banner';
    if (!errorElement) {
        hideError(errorClass);
    }

    const userId = document.getElementById('verifyCustomerId').value;
    sessionStorage.removeItem('dreamCardCustomer');
    toggleLoadingBtn('verify-customer-id');
    grecaptcha.ready(async () => {
        try {
            const captchaToken = await grecaptcha.execute('6LfQlyAqAAAAAEoCCRS81zjJuBwkoBNghyXp4_kA', { action: 'CUSTOMER_ID_SUBMIT' });
            const response = await fetch(!customerId ? `${PROXY}/verify-customer-id` : `${PROXY}/verify-customer-id/customer-logged-in`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ userId, captchaToken }),
            });

            if (!response.ok) {
                throw new Error('somethingWrong');
            }
            const jsonResponse = await response.json();

            if (!jsonResponse.success) {
                throw new Error('somethingWrong');
            }

            const data = jsonResponse.data;
            sessionStorage.setItem('otp-uuid', data.uuid);
            if (data.phone) {
                tempDisableCodeRequest();
                openOtpLoginPopup(null, 'otp-code');
                closeOtpLoginPopup('verify-customer-id');
                document.querySelector('#phoneNumberId').textContent = data.phone;
            } else {
                openOtpLoginPopup(null, 'phone-register');
                closeOtpLoginPopup('verify-customer-id');
            }
        } catch (error) {
            console.error(error);
            showError(errorClass, 'somethingWrong');
        } finally {
            toggleLoadingBtn('verify-customer-id');
            document.getElementById('send-otp-code').disabled = false;
        }
    });
};
